<style scoped>

</style>

<template>
    <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
        <label class="control-label">{{controller.name}}</label>
        
            <div class="input-group date">
                <input type="text" class="form-control" @blur="setValue"/>
                <div class="input-group-addon">
                    <span class="glyphicon glyphicon-th"></span>
                </div>
            </div>
            <span class="help-block" v-if="controller.hasWarning || controller.hasError">
                <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.hasError,'fa-exclamation-triangle' : controller.hasWarning }"></i>
                <small>{{controller.message}}</small>
            </span>
        
    </div>
</template>
<script>
    import $ from 'jquery';
    import moment from 'moment';
    import datepicker from 'bootstrap-datepicker'
    import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'

    export default {
        props: ['controller', 'endDate','startDate'],
        data: function () {
            return {
                dateField: null,
                datePicker: undefined
            }
        },
        watch: {
            'controller.value': function (val) {
                if (moment(val).diff(this.dateField.datepicker('getDate'), 'days') > 0) {
                    var formattedDate = moment(val).format('DD/MM/YYYY');
                    this.dateField.datepicker('setDate', formattedDate)
                }
            }
        },
        mounted: function () {
            this.dateField = $(this.$el).find(".date")
            var that = this;
            var options = {
                format: "dd/M/yyyy",
                keepEmptyValues: true,
                autoclose: true,
            }

            if (this.startDate) {
                //options.startDate = moment(new Date()).toDate();
                options.startDate = this.startDate
            }
            else{
                options.startDate = moment(this.controller.value).toDate()
            }

            if (this.endDate) {
                //var diff = moment(this.endDate).diff(moment(new Date()), 'days')+1;
                //var param = "+" + diff + "d";
                //console.log("setting end date of cycle to ", this.endDate, param);
                //options.endDate = param;
                options.endDate = moment(this.endDate).toDate();
            }

            console.log("Starting Datepicker with ", options)

            this.datePicker = this.dateField.datepicker(options)
                .on('changeDate', function (e) {
                    if (that.controller.value) {
                        console.log("Changing value of datepicker  ", that.controller.value, that.dateField.datepicker('getDate'))
                        that.controller.value = that.dateField.datepicker('getDate')

                    }
                    });

            if (this.controller.value && this.controller.value != null) {
                var formattedDate1 = moment(this.controller.value).toDate();
                console.log("1 Setting Mounted Date to ", formattedDate1)
                this.dateField.datepicker('update', formattedDate1)
            }
            else {
                console.log(" 2 Setting Mounted Date to ", options.startDate)
                this.dateField.datepicker('update', options.startDate)
            }

        },
        methods: {
            setValue: function () {
                this.controller.value = this.dateField.datepicker('getDate')
            }
        }
    }

</script>


// WEBPACK FOOTER //
// datepicker.scp.html?c8af1824